var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHuobi = function SvgHuobi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.796,
    cy: 12.733,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.626 4.741c.842.643 1.95 2.619 1.95 4.916 0 1.145-.84 2.248-1.713 3.4-1.02 1.342-2.09 2.75-1.934 4.363.116 1.205.614 2.101.922 2.656.326.586.439.79-.336.572-2.693-.757-5.338-4.855-2.494-8.592.261-.343.567-.667.888-1.007 1.196-1.266 2.601-2.753 2.656-6.25l.002-.003c-.006-.092.055-.057.059-.055Zm3.183 6.435c.017-.029.041-.02.058-.009.56.484 2.13 2.15 1.908 4.792-.229 2.729-2.342 3.927-2.43 3.971-.782.396-.805.786-.896.802-.04.008-.094-.059-.232-.23-.777-.963-2.16-2.757.266-6.477.715-1.097 1.28-2.29 1.326-2.85Z",
    fill: "#000"
  })));
};

export default SvgHuobi;